// extracted by mini-css-extract-plugin
export default {"modalOverlay":"YB-z","modalContent":"ZB-z","header":"_B-z","close":"aC-z"};